module.exports = __webpack_public_path__ + "static/media/HeroLogo.b102168e.png";